"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.keyPressHelper=e=>(r,...t)=>{if(e&&("Enter"===r.key||"Spacebar"===r.key||" "===r.key))return r.preventDefault(),e(...t)};
//# sourceMappingURL=accessibility.js.map
